__turbopack_context__.v({
  "SButton": "cT8l_q_SButton",
  "SWatchlistIcon": "cT8l_q_SWatchlistIcon",
});
